import { hostnameMatchesDomainList } from '../../utils/hostname-matches-domains';
import { AuthenticatedExternalLinkRoute } from '../authenticated-external-link-options';

export function findAuthenticatedExternalLinkRoute(
  href: string,
  routes: readonly AuthenticatedExternalLinkRoute[]
): AuthenticatedExternalLinkRoute | null {
  try {
    const hostname = new URL(href).hostname;

    return (
      routes.find((route) =>
        hostnameMatchesDomainList(hostname, route.domains)
      ) ?? null
    );
  } catch {
    return null;
  }
}

export interface HandleAuthenticatedExternalLinkClickOptions {
  event: MouseEvent;
  link: HTMLAnchorElement;
  routes: readonly AuthenticatedExternalLinkRoute[];
  openRoute: (
    route: AuthenticatedExternalLinkRoute,
    sourceHref: string,
    trackingId?: string
  ) => void;
}

export function handleAuthenticatedExternalLinkClick({
  event,
  link,
  routes,
  openRoute
}: HandleAuthenticatedExternalLinkClickOptions): boolean {
  const route = findAuthenticatedExternalLinkRoute(link.href, routes);

  if (!route) {
    return false;
  }

  event.preventDefault();
  openRoute(route, link.href, link.dataset['trackingId']);

  return true;
}
